import { DocumentCreationForm } from 'components/Pages/Documents';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const DocumentCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/documentacoes');
  }, [navigate]);

  return (
    <Scaffold>
      <DocumentCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
